import translations from "./translations.json";

export const getTranslation = (pageKey, wordKey, language) => {
  try {
    if (
      pageKey &&
      wordKey &&
      language &&
      translations[pageKey] &&
      translations[pageKey][wordKey] &&
      translations[pageKey][wordKey][language]
    ) {
      return translations[pageKey][wordKey][language];
    }

    return wordKey || translations["auth"]["unknownError"][language];
  } catch (err) {
    console.error("Translation error:", err, { pageKey, wordKey, language });
    return "Unknown error";
  }
};
